const constant =  {
        rmm: {
            retailer: "Retailer",
            financer: "Financer",
            distributor: "Distributor"
        },
        emisafepro: {
            retailer: "Retailer",
            financer: "Distributor",
            distributor: "Super Distributor"
        },
        local: {
            retailer: "Retailer",
            financer: "Financer",
            distributor: "Distributor"
        }
};

const APP_CONST = constant[process.env.REACT_APP_APP_CONFIG] || constant.local;
export {
    APP_CONST
};